import { useTranslation } from "react-i18next";
import InfoFlyUpModal from "../../InfoFlyUpModal/index";
import InfoModal from "../../InfoFlyUpModal/components/InfoModal";

export interface MentalWellbeingModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export default function MentalWellbeingModal({
  isOpen,
  onClose,
}: MentalWellbeingModalProps = {}) {
  const { t } = useTranslation();

  const modalProps = {
    title: t("HealthChart.mentalWellbeingModal.title"),
    description: t("HealthChart.mentalWellbeingModal.description"),
    importanceTitle: t("HealthChart.mentalWellbeingModal.importance.title"),
    textList: t("HealthChart.mentalWellbeingModal.list", {
      returnObjects: true,
    }) as string[],
  };

  if (isOpen !== undefined && onClose !== undefined) {
    return (
      <InfoModal
        isOpen={isOpen}
        handleClose={onClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        textList={modalProps.textList}
      />
    );
  }

  return (
    <InfoFlyUpModal
      cardProps={{
        title: t("HealthChart.mentalWellbeingModal.card.title"),
        description: t("HealthChart.mentalWellbeingModal.card.description"),
      }}
      modalProps={modalProps}
    />
  );
}
